import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { getCookie, setCookie } from './core/utils';
import { SnackBarService } from './shared/components/snackbar/snack-bar.service';

@Component({
  selector: 'sparrow-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private snackBarService: SnackBarService,
  ) {}

  ngOnInit() {
    if (!getCookie('SPARROW_USE_LANGUAGE')) {
      setCookie('SPARROW_USE_LANGUAGE', 'en', 99999999);
    }

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(() => window.scrollTo(0, 0));

    const isIEBrowser = /msie\s|trident\//i.test(window.navigator.userAgent);
    if (isIEBrowser) {
      this.snackBarService.showInfoMessage(
        $localize`:@@ieBannerMessage:Looks like you’re using the Internet Explorer. For the best experience we recommend to switch to any other modern browser.`,
        {
          verticalPosition: 'top',
          politeness: 'assertive',
          duration: 10000,
        },
      );
    }

    // added for mobile, since mobile browsers have different vh calculation
    window.addEventListener('resize', () => {
      // We execute the same script as before
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
